import { useState } from "react";
import "./onboarding.css";

export interface OnboardingSlide {
  title: string;
  body: string;
}

export interface OnboardingProps {
  open: boolean;
  slides: OnboardingSlide[];
  onComplete: () => void;
  onSkip?: () => void;
}

export function Onboarding({ open, slides, onComplete, onSkip }: OnboardingProps) {
  const [step, setStep] = useState(0);

  if (!open || slides.length === 0) return null;

  const current = slides[step];
  const isLast = step >= slides.length - 1;

  const finish = () => {
    setStep(0);
    onComplete();
  };

  const skip = () => {
    setStep(0);
    (onSkip ?? onComplete)();
  };

  return (
    <div className="jari-onboarding-backdrop" role="dialog" aria-modal="true">
      <div className="jari-onboarding">
        <p className="jari-onboarding__step">
          Stap {step + 1} van {slides.length}
        </p>
        <h2>{current.title}</h2>
        <p>{current.body}</p>
        <div className="jari-onboarding__dots" aria-hidden>
          {slides.map((_, i) => (
            <span
              key={i}
              className={
                i === step
                  ? "jari-onboarding__dot jari-onboarding__dot--active"
                  : "jari-onboarding__dot"
              }
            />
          ))}
        </div>
        <div className="jari-onboarding__actions">
          <button type="button" className="jari-btn" onClick={skip}>
            Overslaan
          </button>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            {step > 0 && (
              <button
                type="button"
                className="jari-btn"
                onClick={() => setStep((s) => s - 1)}
              >
                Vorige
              </button>
            )}
            {isLast ? (
              <button type="button" className="jari-btn jari-btn--primary" onClick={finish}>
                Aan de slag
              </button>
            ) : (
              <button
                type="button"
                className="jari-btn jari-btn--primary"
                onClick={() => setStep((s) => s + 1)}
              >
                Volgende
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
